// Indicatifs téléphoniques — tous les pays, RDC en premier et par défaut (connexion sans mot de
// passe, 2026-10-28). Même fichier dans les 3 apps. Drapeau calculé depuis le code ISO.
export const DEFAULT_COUNTRY = 'CD';

export const COUNTRIES = [
  { iso: 'CD', name: 'RD Congo', dial: '243', max: 9 },
  { iso: 'CG', name: 'Congo-Brazzaville', dial: '242', max: 9 },
  { iso: 'RW', name: 'Rwanda', dial: '250', max: 9 },
  { iso: 'BI', name: 'Burundi', dial: '257', max: 8 },
  { iso: 'UG', name: 'Ouganda', dial: '256', max: 9 },
  { iso: 'TZ', name: 'Tanzanie', dial: '255', max: 9 },
  { iso: 'KE', name: 'Kenya', dial: '254', max: 10 },
  { iso: 'ZM', name: 'Zambie', dial: '260', max: 9 },
  { iso: 'AO', name: 'Angola', dial: '244', max: 9 },
  { iso: 'ZA', name: 'Afrique du Sud', dial: '27', max: 9 },
  { iso: 'CM', name: 'Cameroun', dial: '237', max: 9 },
  { iso: 'CF', name: 'Centrafrique', dial: '236', max: 8 },
  { iso: 'SS', name: 'Soudan du Sud', dial: '211', max: 9 },
  { iso: 'GA', name: 'Gabon', dial: '241', max: 8 },
  { iso: 'FR', name: 'France', dial: '33', max: 9 },
  { iso: 'BE', name: 'Belgique', dial: '32', max: 9 },
  { iso: 'US', name: 'États-Unis', dial: '1', max: 10 },
  { iso: 'CA', name: 'Canada', dial: '1', max: 10 },
  { iso: 'GB', name: 'Royaume-Uni', dial: '44', max: 10 },
  { iso: 'DE', name: 'Allemagne', dial: '49', max: 11 },
  { iso: 'CH', name: 'Suisse', dial: '41', max: 9 },
  { iso: 'AF', name: 'Afghanistan', dial: '93', max: 9 },
  { iso: 'AL', name: 'Albanie', dial: '355', max: 9 },
  { iso: 'DZ', name: 'Algérie', dial: '213', max: 9 },
  { iso: 'AD', name: 'Andorre', dial: '376', max: 9 },
  { iso: 'AR', name: 'Argentine', dial: '54', max: 11 },
  { iso: 'AM', name: 'Arménie', dial: '374', max: 8 },
  { iso: 'AU', name: 'Australie', dial: '61', max: 9 },
  { iso: 'AT', name: 'Autriche', dial: '43', max: 11 },
  { iso: 'AZ', name: 'Azerbaïdjan', dial: '994', max: 9 },
  { iso: 'BH', name: 'Bahreïn', dial: '973', max: 8 },
  { iso: 'BD', name: 'Bangladesh', dial: '880', max: 10 },
  { iso: 'BY', name: 'Biélorussie', dial: '375', max: 9 },
  { iso: 'BJ', name: 'Bénin', dial: '229', max: 10 },
  { iso: 'BO', name: 'Bolivie', dial: '591', max: 8 },
  { iso: 'BA', name: 'Bosnie-Herzégovine', dial: '387', max: 8 },
  { iso: 'BW', name: 'Botswana', dial: '267', max: 8 },
  { iso: 'BR', name: 'Brésil', dial: '55', max: 11 },
  { iso: 'BG', name: 'Bulgarie', dial: '359', max: 9 },
  { iso: 'BF', name: 'Burkina Faso', dial: '226', max: 8 },
  { iso: 'KH', name: 'Cambodge', dial: '855', max: 9 },
  { iso: 'CV', name: 'Cap-Vert', dial: '238', max: 7 },
  { iso: 'CL', name: 'Chili', dial: '56', max: 9 },
  { iso: 'CN', name: 'Chine', dial: '86', max: 11 },
  { iso: 'CY', name: 'Chypre', dial: '357', max: 8 },
  { iso: 'CO', name: 'Colombie', dial: '57', max: 10 },
  { iso: 'KM', name: 'Comores', dial: '269', max: 7 },
  { iso: 'KR', name: 'Corée du Sud', dial: '82', max: 10 },
  { iso: 'CR', name: 'Costa Rica', dial: '506', max: 8 },
  { iso: 'CI', name: "Côte d'Ivoire", dial: '225', max: 10 },
  { iso: 'HR', name: 'Croatie', dial: '385', max: 9 },
  { iso: 'CU', name: 'Cuba', dial: '53', max: 8 },
  { iso: 'DK', name: 'Danemark', dial: '45', max: 8 },
  { iso: 'DJ', name: 'Djibouti', dial: '253', max: 8 },
  { iso: 'DO', name: 'République dominicaine', dial: '1', max: 10 },
  { iso: 'EG', name: 'Égypte', dial: '20', max: 10 },
  { iso: 'AE', name: 'Émirats arabes unis', dial: '971', max: 9 },
  { iso: 'EC', name: 'Équateur', dial: '593', max: 9 },
  { iso: 'ER', name: 'Érythrée', dial: '291', max: 7 },
  { iso: 'ES', name: 'Espagne', dial: '34', max: 9 },
  { iso: 'EE', name: 'Estonie', dial: '372', max: 8 },
  { iso: 'SZ', name: 'Eswatini', dial: '268', max: 8 },
  { iso: 'ET', name: 'Éthiopie', dial: '251', max: 9 },
  { iso: 'FI', name: 'Finlande', dial: '358', max: 10 },
  { iso: 'GM', name: 'Gambie', dial: '220', max: 7 },
  { iso: 'GE', name: 'Géorgie', dial: '995', max: 9 },
  { iso: 'GH', name: 'Ghana', dial: '233', max: 9 },
  { iso: 'GR', name: 'Grèce', dial: '30', max: 10 },
  { iso: 'GN', name: 'Guinée', dial: '224', max: 9 },
  { iso: 'GQ', name: 'Guinée équatoriale', dial: '240', max: 9 },
  { iso: 'GW', name: 'Guinée-Bissau', dial: '245', max: 7 },
  { iso: 'HT', name: 'Haïti', dial: '509', max: 8 },
  { iso: 'HU', name: 'Hongrie', dial: '36', max: 9 },
  { iso: 'IN', name: 'Inde', dial: '91', max: 10 },
  { iso: 'ID', name: 'Indonésie', dial: '62', max: 11 },
  { iso: 'IQ', name: 'Irak', dial: '964', max: 10 },
  { iso: 'IR', name: 'Iran', dial: '98', max: 10 },
  { iso: 'IE', name: 'Irlande', dial: '353', max: 9 },
  { iso: 'IL', name: 'Israël', dial: '972', max: 9 },
  { iso: 'IT', name: 'Italie', dial: '39', max: 10 },
  { iso: 'JM', name: 'Jamaïque', dial: '1', max: 10 },
  { iso: 'JP', name: 'Japon', dial: '81', max: 10 },
  { iso: 'JO', name: 'Jordanie', dial: '962', max: 9 },
  { iso: 'KZ', name: 'Kazakhstan', dial: '7', max: 10 },
  { iso: 'KW', name: 'Koweït', dial: '965', max: 8 },
  { iso: 'LA', name: 'Laos', dial: '856', max: 10 },
  { iso: 'LS', name: 'Lesotho', dial: '266', max: 8 },
  { iso: 'LV', name: 'Lettonie', dial: '371', max: 8 },
  { iso: 'LB', name: 'Liban', dial: '961', max: 8 },
  { iso: 'LR', name: 'Liberia', dial: '231', max: 9 },
  { iso: 'LY', name: 'Libye', dial: '218', max: 9 },
  { iso: 'LT', name: 'Lituanie', dial: '370', max: 8 },
  { iso: 'LU', name: 'Luxembourg', dial: '352', max: 9 },
  { iso: 'MG', name: 'Madagascar', dial: '261', max: 9 },
  { iso: 'MY', name: 'Malaisie', dial: '60', max: 10 },
  { iso: 'MW', name: 'Malawi', dial: '265', max: 9 },
  { iso: 'MV', name: 'Maldives', dial: '960', max: 7 },
  { iso: 'ML', name: 'Mali', dial: '223', max: 8 },
  { iso: 'MT', name: 'Malte', dial: '356', max: 8 },
  { iso: 'MA', name: 'Maroc', dial: '212', max: 9 },
  { iso: 'MU', name: 'Maurice', dial: '230', max: 8 },
  { iso: 'MR', name: 'Mauritanie', dial: '222', max: 8 },
  { iso: 'MX', name: 'Mexique', dial: '52', max: 10 },
  { iso: 'MD', name: 'Moldavie', dial: '373', max: 8 },
  { iso: 'MC', name: 'Monaco', dial: '377', max: 9 },
  { iso: 'MN', name: 'Mongolie', dial: '976', max: 8 },
  { iso: 'ME', name: 'Monténégro', dial: '382', max: 8 },
  { iso: 'MZ', name: 'Mozambique', dial: '258', max: 9 },
  { iso: 'MM', name: 'Myanmar', dial: '95', max: 10 },
  { iso: 'NA', name: 'Namibie', dial: '264', max: 9 },
  { iso: 'NP', name: 'Népal', dial: '977', max: 10 },
  { iso: 'NI', name: 'Nicaragua', dial: '505', max: 8 },
  { iso: 'NE', name: 'Niger', dial: '227', max: 8 },
  { iso: 'NG', name: 'Nigeria', dial: '234', max: 10 },
  { iso: 'NO', name: 'Norvège', dial: '47', max: 8 },
  { iso: 'NZ', name: 'Nouvelle-Zélande', dial: '64', max: 10 },
  { iso: 'OM', name: 'Oman', dial: '968', max: 8 },
  { iso: 'PK', name: 'Pakistan', dial: '92', max: 10 },
  { iso: 'PA', name: 'Panama', dial: '507', max: 8 },
  { iso: 'PY', name: 'Paraguay', dial: '595', max: 9 },
  { iso: 'NL', name: 'Pays-Bas', dial: '31', max: 9 },
  { iso: 'PE', name: 'Pérou', dial: '51', max: 9 },
  { iso: 'PH', name: 'Philippines', dial: '63', max: 10 },
  { iso: 'PL', name: 'Pologne', dial: '48', max: 9 },
  { iso: 'PT', name: 'Portugal', dial: '351', max: 9 },
  { iso: 'QA', name: 'Qatar', dial: '974', max: 8 },
  { iso: 'RO', name: 'Roumanie', dial: '40', max: 9 },
  { iso: 'RU', name: 'Russie', dial: '7', max: 10 },
  { iso: 'SN', name: 'Sénégal', dial: '221', max: 9 },
  { iso: 'RS', name: 'Serbie', dial: '381', max: 9 },
  { iso: 'SC', name: 'Seychelles', dial: '248', max: 7 },
  { iso: 'SL', name: 'Sierra Leone', dial: '232', max: 8 },
  { iso: 'SG', name: 'Singapour', dial: '65', max: 8 },
  { iso: 'SK', name: 'Slovaquie', dial: '421', max: 9 },
  { iso: 'SI', name: 'Slovénie', dial: '386', max: 8 },
  { iso: 'SO', name: 'Somalie', dial: '252', max: 9 },
  { iso: 'SD', name: 'Soudan', dial: '249', max: 9 },
  { iso: 'LK', name: 'Sri Lanka', dial: '94', max: 9 },
  { iso: 'SE', name: 'Suède', dial: '46', max: 9 },
  { iso: 'SY', name: 'Syrie', dial: '963', max: 9 },
  { iso: 'TW', name: 'Taïwan', dial: '886', max: 9 },
  { iso: 'TD', name: 'Tchad', dial: '235', max: 8 },
  { iso: 'CZ', name: 'Tchéquie', dial: '420', max: 9 },
  { iso: 'TH', name: 'Thaïlande', dial: '66', max: 9 },
  { iso: 'TG', name: 'Togo', dial: '228', max: 8 },
  { iso: 'TN', name: 'Tunisie', dial: '216', max: 8 },
  { iso: 'TR', name: 'Turquie', dial: '90', max: 10 },
  { iso: 'UA', name: 'Ukraine', dial: '380', max: 9 },
  { iso: 'UY', name: 'Uruguay', dial: '598', max: 8 },
  { iso: 'VE', name: 'Venezuela', dial: '58', max: 10 },
  { iso: 'VN', name: 'Viêt Nam', dial: '84', max: 10 },
  { iso: 'YE', name: 'Yémen', dial: '967', max: 9 },
  { iso: 'ZW', name: 'Zimbabwe', dial: '263', max: 9 },
  { iso: 'ST', name: 'Sao Tomé-et-Principe', dial: '239', max: 7 },
  { iso: 'SA', name: 'Arabie saoudite', dial: '966', max: 9 },
  { iso: 'GT', name: 'Guatemala', dial: '502', max: 8 },
  { iso: 'HN', name: 'Honduras', dial: '504', max: 8 },
  { iso: 'SV', name: 'Salvador', dial: '503', max: 8 },
  { iso: 'IS', name: 'Islande', dial: '354', max: 7 },
  { iso: 'MK', name: 'Macédoine du Nord', dial: '389', max: 8 },
  { iso: 'UZ', name: 'Ouzbékistan', dial: '998', max: 9 },
  { iso: 'KG', name: 'Kirghizistan', dial: '996', max: 9 },
  { iso: 'TJ', name: 'Tadjikistan', dial: '992', max: 9 },
  { iso: 'TM', name: 'Turkménistan', dial: '993', max: 8 },
  { iso: 'PG', name: 'Papouasie-Nouvelle-Guinée', dial: '675', max: 8 },
  { iso: 'FJ', name: 'Fidji', dial: '679', max: 7 },
  { iso: 'TT', name: 'Trinité-et-Tobago', dial: '1', max: 10 },
  { iso: 'BS', name: 'Bahamas', dial: '1', max: 10 },
  { iso: 'BB', name: 'Barbade', dial: '1', max: 10 },
  { iso: 'BZ', name: 'Belize', dial: '501', max: 7 },
  { iso: 'BT', name: 'Bhoutan', dial: '975', max: 8 },
  { iso: 'BN', name: 'Brunei', dial: '673', max: 7 },
  { iso: 'GY', name: 'Guyana', dial: '592', max: 7 },
  { iso: 'SR', name: 'Suriname', dial: '597', max: 7 },
  { iso: 'LI', name: 'Liechtenstein', dial: '423', max: 9 },
  { iso: 'SM', name: 'Saint-Marin', dial: '378', max: 10 },
  { iso: 'KP', name: 'Corée du Nord', dial: '850', max: 10 },
  { iso: 'TL', name: 'Timor oriental', dial: '670', max: 8 },
  { iso: 'WS', name: 'Samoa', dial: '685', max: 7 },
  { iso: 'TO', name: 'Tonga', dial: '676', max: 7 },
  { iso: 'VU', name: 'Vanuatu', dial: '678', max: 7 },
  { iso: 'SB', name: 'Îles Salomon', dial: '677', max: 7 },
  { iso: 'MO', name: 'Macao', dial: '853', max: 8 },
  { iso: 'HK', name: 'Hong Kong', dial: '852', max: 8 },
  { iso: 'PS', name: 'Palestine', dial: '970', max: 9 },
  { iso: 'RE', name: 'La Réunion', dial: '262', max: 9 },
  { iso: 'YT', name: 'Mayotte', dial: '262', max: 9 },
  { iso: 'GP', name: 'Guadeloupe', dial: '590', max: 9 },
  { iso: 'MQ', name: 'Martinique', dial: '596', max: 9 },
  { iso: 'GF', name: 'Guyane française', dial: '594', max: 9 },
  { iso: 'PF', name: 'Polynésie française', dial: '689', max: 8 },
  { iso: 'NC', name: 'Nouvelle-Calédonie', dial: '687', max: 6 },
];

/** Drapeau emoji à partir du code ISO (deux lettres → symboles régionaux). */
export function flagOf(iso) {
  return String(iso || '').toUpperCase().replace(/./g, (c) => String.fromCodePoint(127397 + c.charCodeAt(0)));
}

export function countryByIso(iso) {
  return COUNTRIES.find((c) => c.iso === iso) || COUNTRIES[0];
}

/** Numéro international à partir d'un pays et des chiffres saisis (0 initial retiré). */
export function buildPhone(country, digits) {
  const d = String(digits || '').replace(/[^0-9]/g, '').replace(/^0+/, '');
  return d ? `+${country.dial}${d}` : '';
}
